import React from "react";
import { useDispatch } from "react-redux";

import { closeModal } from "state/actions/ModalActions";
import DecisionDialog, { IDecisionDialogProps } from "./DecisionDialog";

type IDecisionDialogModalProps = Omit<
  IDecisionDialogProps,
  "isOpen" | "onRequestClose"
>;

const DecisionDialogModal: React.FC<IDecisionDialogModalProps> = ({
  actions,
  ...props
}) => {
  const dispatch = useDispatch();
  const close = () => dispatch(closeModal());

  const closingActions = actions.map(action => ({
    ...action,
    onClick: () => {
      close();
      action.onClick?.();
    }
  }));

  return (
    <DecisionDialog
      isOpen={true}
      actions={closingActions}
      onRequestClose={close}
      {...props}
    />
  );
};

export default DecisionDialogModal;
